import { Form } from "react-bootstrap";

type Props = {
  title?: string;
  onTitleChanged: (value: string) => void;
  areaName: string;
};

export const SelectByPointPanel = (props: Props) => {
  const { title, onTitleChanged, areaName } = props;

  return (
    <div className="d-flex flex-column gap-2">
      <Form.Group>
        <Form.Label className="mb-1">タイトル</Form.Label>
        <Form.Control
          type="text"
          value={title ?? ""}
          onChange={(e) => onTitleChanged(e.currentTarget.value)}
          placeholder=""
          disabled={title === undefined}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label className="mb-1">地区名</Form.Label>
        <Form.Control type="text" value={areaName} placeholder="自動で設定されます" disabled />
      </Form.Group>
      <Form.Label style={{ fontSize: "smaller", marginTop: "1rem" }}>
        ※ 地図をクリックして位置を指定してください
      </Form.Label>
    </div>
  );
};
